<template>
  <div class="container-fluid">
    <div id="title" class="row">
      <div class="col-1">
        <svg id="header" class="bd-placeholder-img mr-2 rouded" width="28"
        height="28" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid slice" focusable="false" role="img" aria-lavel="Placeholder: 32x32">
        <rect width="100%" height="100%" fill="#00C3E0"></rect>
        </svg>
      </div>
      <div class="col-5">
        <h5>import CSV</h5>
      </div>
      <div class="col-3">
        <button id="backBtn" type="button" class="btn-sm btn-outline-info"
        v-on:click="back">キャンセルする</button>
      </div>
      <div class="col-3">
        <button type="button" class="btn-sm btn-outline-primary"
        v-on:click="download">フォーマットを出力する</button>
      </div>
    </div>
    <div class="row">
      <div class="col-1">
      </div>
      <div class="col-4">
        <label>操作を選択してください</label>
          <select class="form-control" v-model="current">
            <option value="1">連絡先を作成する</option>
            <option value="3" v-show="$store.state.contact.extraContactId !== 0">連絡先を削除する</option>
            <option value="2">連絡先とグループの紐づけを登録・更新する</option>
          </select>
      </div>
    </div>
    <!-- 紐づけを選択したときの注意書き表示 -->
    <div v-show="current === '2'" class="row pt-2">
      <div class="col-1">
      </div>
      <div class="col-11 ">
        <p class="m-0" style="color: red;">{{importConnectionNote}}</p>
      </div>
    </div>
    <div class="row py-2">
      <div class="col-1">
      </div>
      <div class="col-11">
        <form enctype="multipart/form-data" @submit.prevent="upload">
          <input type="file" ref="file" name="csvfile" v-on:change="selectedFile"/>
          <button class="btn btn-info">Upload</button>
        </form>
      </div>
    </div>

    <p>{{message}}</p>
  </div>
</template>

<script>
import axios from 'axios'
import FileSaver from 'file-saver'
import { sessions } from '../../mixin/session'
import { path } from '../../mixin/path'
import { headers } from '../../mixin/headers'

export default {
  name: 'Import',
  mixins: [sessions,path,headers],
  props: ['realms'],  
  data: function(){
    return {
      current: '1',
      message: '',
      uploadFile: null,
      importConnectionNote: "ファイルに含まれる連絡先の既存の紐づけ情報はクリアされ、アップロードした紐づけ情報に更新されます。", // V1では仕様変更になるため、メニュー選択時とUploadボタン押下時に注意書きを表示する
    }
  },
  methods: {
    selectedFile(event){
      let files = event.target.files
      this.uploadFile = files[0]
    },
    upload(){
      if (this.uploadFile === null){
        alert('ファイルが指定されていません。')
        return
      }

      if (this.current === '2') {
        const message = `${this.importConnectionNote}`;
        if (!this.confirmWithTypeIn(message)) {
          return;
        }
      }

      if (this.current === '3') {
        const message = "このままファイルをアップロードしますか？\nバックアップとして連絡先情報をエクスポートすることを推奨します。";
        if (!this.confirmWithTypeIn(message)) {
          return;
        }
      }

      var blob = new Blob([this.uploadFile], {type: 'application/octet-stream'})
      var fileName = this.uploadFile.name
      var hospitalCode = this.$store.getters.hospital.code
      this.$cognito.isAuthenticated().then((session) => {
      if(session){
        var apiPath = null
        if (this.current === '1') {
          apiPath = "/api/contact/csv/"
        } else if(this.current === '2') {
          apiPath = "/api/connection/csv/"
        } else if(this.current === '3') {
          apiPath = "/api/contact/delete-csv/"
        }
        var accessToken = this.getAccessToken(this.$cognito,session)
        axios.post(apiPath + hospitalCode + "/" + fileName, blob,{
              headers: this.headersUploadStream(accessToken)
        }).then(res => {
          if(res.errorMessage) {
            this.message = res.errorMessage
          } else {
            this.reset()
            alert('ファイルをアップロードしました。')
            this.back()
          }
        })
      }}).catch((err) => {
        this.message = err.message
      })
    },
    confirmWithTypeIn(confirmationMessage) {
      const requiredText = "確認";
      const confirmText = `${confirmationMessage}\n\nアップロードする場合は「${requiredText}」を入力してください。`;
      let input = window.prompt(confirmText);
      while (input !== requiredText && input !== null) {
          input = window.prompt(`${confirmText}\n入力した文字が間違っています。`);
      }
      return input === requiredText; // "確認"を入力してOKボタンを押した場合のみtrueを返す
    },
    back() {
      this.$router.replace(this.replacePath(this.$cognito,this.realms,'/contacts/contact/index'))
    },
    reset() {
      var input = this.$refs.file
      input.value = ''
      this.uploadFile = null
    },
    download() {
      this.$cognito.isAuthenticated().then((session) => {
        if(session){
          var accessToken = this.getAccessToken(this.$cognito,session)
          var fileName = null
          if (this.current === '1') {
            fileName = 'contacts.csv'
          } else if(this.current === '2') {
            fileName = 'connections.csv'
          } else if(this.current === '3') {
            fileName = 'delete-contacts.csv'
          }
          axios.post("/api/csv-format/download/", {
            fileName: fileName
          },{
            headers: this.headers(accessToken),
            responseType: "blob"
          }).then(response => {
            const blob = new Blob([response.data], {
              type: response.data.type
            })
            FileSaver.saveAs(blob, fileName)
          }).catch(err => {
            this.message = err.message
          })
        }
      }).catch((err) => {
        this.message = err.message
      })
    }
  }
}
</script>

<style scoped>
#header {
  float: right;
}
#title {
  padding: 10px;
}
#backBtn {
  float:right;
}
#register_button {
  margin-top: 30px;
}
</style>